import apiClient from "../config/apiClient";


export const CancelAppointment = async (data) => {
  const token = window.localStorage.getItem("token");

  return await apiClient.patch(
    `/public/portal?url=front-desk/appointments/${data}/cancel`,
    {}, // empty body (if none is needed)
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};